import http from "./http";

export const fetchPartners = () => http.get("/partners");
export const fetchSinglePartner = (id) => http.get(`/partners/${id}`)

export const addPartner = (credentials) => {
    return http.post("/investments/partners/add", credentials)
}

export const updatePartner = (id, payload) => {
    return http.patch(`investments/partners/update/${id}`, payload) 
}

export const regenerateVirtualAccount = (id) => http.post(`/partners/virtual-account/${id}/regenerate`);